import { RICH_TEXT_CONTENT_FIELDS } from './richTextLinksFields'

/** wwwPages.model inline fragments — fields must match Contentful GraphQL schema. */
export const WWW_PAGE_MODEL_FIELDS = `
  __typename
  ... on WwwBlogPosts {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    shortDescription
    customPublishedDate
    follow
    index
    content { ${RICH_TEXT_CONTENT_FIELDS} }
    videoUrl { ${RICH_TEXT_CONTENT_FIELDS} }
    image { url title width height contentType }
    author {
      fullName
      slug
      description
      jobTitle
      facebook
      twitter
      sys { id }
      avatar { url title width height }
    }
    reviewedBy {
      fullName
      slug
      description
      jobTitle
      sys { id }
      avatar { url title width height }
    }
  }
  ... on WwwArticlePages {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    customPublishedDate
    follow
    index
    articleContent { ${RICH_TEXT_CONTENT_FIELDS} }
    videoUrl { ${RICH_TEXT_CONTENT_FIELDS} }
    image { url title width height contentType }
    author {
      fullName
      slug
      description
      jobTitle
      facebook
      twitter
      sys { id }
      avatar { url title width height }
    }
    reviewedBy {
      fullName
      slug
      description
      jobTitle
      sys { id }
      avatar { url title width height }
    }
  }
  ... on WwwDocumentPages {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    subtitle
    follow
    index
    documentContent: content { ${RICH_TEXT_CONTENT_FIELDS} }
  }
  ... on WwwDebtConsolidationStatesCities {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    follow
    index
    state
    city
    slug
    demonym
    flagIcon { url title width height contentType }
    flagseal { url title width height contentType }
    author {
      fullName
      slug
      description
      jobTitle
      facebook
      twitter
      sys { id }
      avatar { url title width height }
    }
    geoContent: content { ${RICH_TEXT_CONTENT_FIELDS} }
  }
  ... on WwwFile {
    sys { id publishedAt }
    title
    file { url title width height contentType }
  }
  ... on WwwClientStories {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    follow
    index
    text
    link
  }
  ... on WwwDisclaimerPages {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    follow
    index
    slug
    subtitle
    disclaimerContent: content { ${RICH_TEXT_CONTENT_FIELDS} }
  }
  ... on WwwIFramePages {
    sys { id publishedAt }
    title
    metaTitle
    metaDescription
    script
    follow
    index
    iframeContent: content
  }
`
